var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"select-box",class:{
    'select-box--active': _vm.isActive,
    'select-box--disabled': _vm.disabled,
  },on:{"click":_vm.handleClick}},[_c('div',{staticClass:"select-box__row"},[_c('div',{staticClass:"select-box__text"},[_c('div',{staticClass:"select-box__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"select-box__description"},[_vm._v(" "+_vm._s(_vm.description)+" ")])]),_c('div',{staticClass:"select-box__label"},[_vm._t("label",function(){return [_vm._v(" "+_vm._s(_vm.label)+" ")]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }